import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { HubEndpoint } from '../../constants/hub-endpoint';
import { API_URL } from '../../../../../../services/config';
import { switchMap } from 'rxjs/operators';
import { HubItemFacade } from '../hub-item.facade';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import {
  HubFrequentDriverModel,
  HubFrequentDriverListSearchCriteria,
  HubFrequentDriverSearchCriteria,
} from '../../models/hub-frequent-driver-list.model';

@Injectable({
  providedIn: 'root',
})
export class HubFrequentDriverListService {
  constructor(private http: WrapperHttpService, private hubItemFacade: HubItemFacade) {}

  getDriverListData(searchCriteria: HubFrequentDriverListSearchCriteria): Observable<HubFrequentDriverModel[]> {
    return this.hubItemFacade.hubId$.pipe(
      switchMap((id: number) => {
        const url =
          `${API_URL}${HubEndpoint.Base}/${id}${HubEndpoint.DriverList}?` + getQueryStringFromObject(searchCriteria);

        return this.http.withLoading().get<HubFrequentDriverModel[]>(url);
      }),
    );
  }

  searchDriver(hubId: number, searchCriteria: HubFrequentDriverSearchCriteria): Observable<HubFrequentDriverModel[]> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.DriverList}${
      HubEndpoint.Search
    }?${getQueryStringFromObject(searchCriteria)}`;

    return this.http.withLoading().get<HubFrequentDriverModel[]>(url);
  }

  saveDriver(driver: HubFrequentDriverModel): Observable<HubFrequentDriverModel> {
    return this.hubItemFacade.hubId$.pipe(
      switchMap((id: number) => {
        const url = `${API_URL}${HubEndpoint.Base}/${id}${HubEndpoint.DriverList}`;

        return this.http.post<HubFrequentDriverModel>(url, driver);
      }),
    );
  }

  deleteDriverListItem(hubId: number, driverId: number): Observable<void> {
    return this.http
      .withLoading()
      .delete<void>(`${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.DriverList}/${driverId}`);
  }
}
